import Api from "./ApiNode";

export default {
    getAllLocation(payload, config) {
        let AllLocationList = Api().post("master/dropdown/loc", payload, config);
        return AllLocationList;
    },

    getAllPendingSlineInv(payload, config) {
        let AllLocationList = Api().post("master/dropdown/pending-inv_sline", payload, config);
        return AllLocationList;
    },
};



// WEBPACK FOOTER //
// ./src/services/DropdownService.js